import React from 'react'
import classNames from 'classnames'

import { DEFAULT_PLATFORM_REVIEWS, PlatformReview } from '@slite/components'

export function SocialProofs({
  color,
  variant = 'default',
}: {
  color?: string
  variant?: 'center' | 'default'
}) {
  return (
    <div
      className={classNames(
        'flexbox flexbox-wrap flexbox-align-center flexbox-column-gap-32 flexbox-row-gap-16 margin-top-12',
        variant === 'center' && 'flexbox-justify-center'
      )}
    >
      {DEFAULT_PLATFORM_REVIEWS.map((review) => (
        <PlatformReview
          key={review.platform}
          platform={review.platform}
          rating={review.rating}
          maxRating={review.maxRating}
          link={review.link}
          color={color ?? 'primary'}
          variant={variant}
        />
      ))}
    </div>
  )
}
